import { useTheme } from "@emotion/react";
import { Grid, Paper } from "@mui/material";

export default function ScrollContainer({ children }) {
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height;

    return (
        <Grid
            id='scroll-viewer'
            container
            style={{
                position: 'fixed',
                top: scrollViewerTop,
                left: 0,
                height: `calc(100vh - ${scrollViewerTop}px)`,
                overflowX: 'hidden',
                overflowY: 'auto',
                width: '100vw',
                padding: '1.5em 1em 1.5em 1em'
            }}
        >
            <Grid item xs>
                <Paper
                    sx={{
                        p: 1.5,
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        width: 'calc(100% - 1em)',
                        marginLeft: '0.5em',
                        marginTop: '0',
                        marginBottom: '0.5em',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        position: 'relative'
                    }}
                >
                    {children}
                </Paper>
            </Grid>
        </Grid>
    );
}